__turbopack_context__.v({
  "badge": "ParagraphProcessSteps-module__sv_wNG__badge",
  "badgeLabel": "ParagraphProcessSteps-module__sv_wNG__badgeLabel",
  "eyebrow": "ParagraphProcessSteps-module__sv_wNG__eyebrow",
  "grid": "ParagraphProcessSteps-module__sv_wNG__grid",
  "lead": "ParagraphProcessSteps-module__sv_wNG__lead",
  "num": "ParagraphProcessSteps-module__sv_wNG__num",
  "section": "ParagraphProcessSteps-module__sv_wNG__section",
  "step": "ParagraphProcessSteps-module__sv_wNG__step",
  "stepDesc": "ParagraphProcessSteps-module__sv_wNG__stepDesc",
  "stepName": "ParagraphProcessSteps-module__sv_wNG__stepName",
  "title": "ParagraphProcessSteps-module__sv_wNG__title",
  "tooltip": "ParagraphProcessSteps-module__sv_wNG__tooltip",
  "tooltipDesc": "ParagraphProcessSteps-module__sv_wNG__tooltipDesc",
  "tooltipTitle": "ParagraphProcessSteps-module__sv_wNG__tooltipTitle",
});
